<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/branch')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="validateRegister">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Name</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="salesName" v-model="editData.name" name="name" v-validate="'required'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('name') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Codename</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="editData.codename" name="codename" v-validate="'required'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('codename') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>PIC Sales</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <b-form-select name="pic_sales" v-validate="'required'" v-model="editData.branch_pic_sales_id">
                      <option :value="null">Please select</option>
                      <option v-for="item in itemSales" :key="item.id" :value="item.id">{{item.fullname}}</option>
                    </b-form-select>
                  </div>
                  <span class="error">{{ errors.first('pic_sales') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>PIC Customer Service</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <b-form-select name="pic_customer_services" v-validate="'required'" v-model="editData.branch_pic_customer_service_id">
                      <option :value="null">Please select</option>
                      <option v-for="item in itemCS" :key="item.id" :value="item.id">{{item.name}}</option>
                    </b-form-select>
                  </div>
                  <span class="error">{{ errors.first('pic_customer_services') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="address">Address</label>
                </b-col>
                <b-col sm="10">
                  <textarea name="address" class="w-100" rows="3" v-model="editData.address"></textarea>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Longitude</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="editData.lang" name="longitude" type="text"></b-form-input>
                  <span class="error">{{ errors.first('longitude') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Latitude</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="editData.lat" name="latitude" type="text"></b-form-input>
                  <span class="error">{{ errors.first('latitude') }}</span>
                </b-col>
              </b-row>
              <div class="text-right">
                <button type="submit" class="btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'

export default {
  name: 'addbranch',
  data: function () {
    return {
      dataBranch: [],
      itemSales: [],
      itemCS: [],
      editData: {
        name: '',
        codename: '',
        address: '',
        branch_pic_sales_id: null,
        branch_pic_customer_service_id: null,
        lang: 0,
        lat: 0
      },
      options: [
        { value: null, text: 'Please select' },
        { value: 'active', text: 'Active' },
        { value: 'inactive', text: 'Inactive' }
      ]
    }
  },
  methods: {
    validateRegister () {
      this.$validator.validateAll().then((result) => {
        if(result) {
          axios.put('fitness/v1/branch/' + this.$route.query.id, this.editData).then(response => {
            // console.log('test', response)
            this.$router.push('/branch')
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }).catch(error => {
            // console.log('error log', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    fetchData() {
      axios.get('fitness/v1/branch/' + this.$route.query.id).then(response => {
        this.editData.name = response.data.data.name
        this.editData.codename = response.data.data.codename
        this.editData.branch_pic_sales_id = response.data.data.branch_pic_sales_id
        this.editData.branch_pic_customer_service_id = response.data.data.branch_pic_customer_service_id
        this.editData.address = response.data.data.address
        this.editData.lang = response.data.data.lang
        this.editData.lat = response.data.data.lat
        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('crm/v1/sales').then(response => {
        this.itemSales = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('crm/v1/customer_service').then(response => {
        this.itemCS = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
